import FormEdit from './steps/FormEdit.vue';

import { InstallerCapacity, EditDialogAttributes, HocoTarget } from '@/types';

import WithSteps from '@/apps/office/containers/table/shared/dialogs/with-steps';

type FormData = {
  item: HocoTarget;
  formValid: boolean;
};

export default WithSteps<FormData, EditDialogAttributes<HocoTarget>>({
  title: 'office.dialogs.installations.targets.edit.title',

  maxWidth: 600,

  formData() {
    return {
      item: this.$attrs.item,

      formValid: false,
    };
  },

  steps: [
    {
      component: FormEdit,

      isValid() {
        return this.$data.formValid;
      },

      props() {
        return {
          item: this.$data.item,
        };
      },

      value: {
        get() {
          return this.$data.formValid;
        },

        set(isValid: boolean) {
          this.$data.formValid = isValid;
        },
      },

      labels: {
        action: 'dialogs.save',
      },

      async afterStep() {
        await this.$store.dispatch('planning/targets/item:create', {
          item: this.$data.item,
        });

        this.$store.dispatch('planning/targets/settings/search');
      },
    },
  ],
});
